import jobFeedRouteList from '../../app/jobFeed/routes';
import synJobFeedRouteList from '../../app/syndicatedJobs/routes';
import sponsoredAdsRouteList from '../../app/sponsoredAds/routes';
import syndicatedSponsoredAdsRouteList from '../../app/syndicatedSponsoredAds/routes';
import docsRouteList from '../../app/docs/routes';

// LUT-508: Syndicated Sites is retired from the UI. Its routes (app/syndicatedSites/routes) are
// deliberately unregistered rather than deleted so the section can be restored by reverting this
// commit. Bookmarked /syn-sites/* URLs are redirected in PageRouteList/index.js.
const partnerRouteList = [
   ...jobFeedRouteList,
   ...synJobFeedRouteList,
   ...sponsoredAdsRouteList,
   ...syndicatedSponsoredAdsRouteList,
   ...docsRouteList,
];

export default partnerRouteList;
